import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getWallet = createAsyncThunk(
  "wallet/getWallet",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;
      const filterStr = filterRequest(filter);
      const params = new URLSearchParams();

      // Only add non-empty params
      if (page) params.append("page", page);
      if (size) params.append("size", size);
      if (query) params.append("query", query);
      if (owner) params.append("owner", owner);
      if (user) params.append("user", user);
      const url = `/wallet${params.toString() ? '?' + params.toString() : ''}${filterStr}`;

      const response = await axiosInstance.get(url);
      const { data: walletArray, itemsCount, pages } = response.data.data;
      return thunkApi.fulfillWithValue({ data: walletArray, itemsCount, pages });
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    resetWalletState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWallet.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getWallet.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getWallet.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export const { resetWalletState } = walletSlice.actions;
export default walletSlice.reducer;